import { GetProps, Image as ImageAntd } from "antd"

type ImageProps = Readonly<Omit<GetProps<typeof ImageAntd>, "preview">>

function Image(props: ImageProps) {
  return <ImageAntd preview={false} {...props} />
}

export default Image
